import React, { Fragment } from 'react'

import { faUser } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Chip } from '@material-ui/core'
import { Check } from '@material-ui/icons'
import { AbstractEvent, EventDuration } from '@scoir/react-calendar'
import cn from 'classnames'
import { get, head, last } from 'lodash'
import moment from 'moment'
import momentTimeZone from 'moment-timezone'
import PropTypes from 'prop-types'

import sanitizeHtml from 'common/sanitize-html-helper'
import UserAware from 'components/UserAware'
import UnregisterAction from 'components/VisitActions/UnregisterAction'

import { confirmed } from '../../../visit-colors'
import SendChatModal from '../SendChatModal'
import LocationSection from '../components/LocationSection'
import { Section, Title } from '../components/OverlayParts'
import './index.scss'
import requiredPropTypes from './requiredPropTypes'

const getRegisterDeadline = (date, minAdvNotice) => {
  return date.subtract(minAdvNotice, 'days').format('ddd MMM Do, YYYY')
}

export { default as WeekView } from './WeekView'
export { default as MonthView } from './MonthView'

export default class CollegeVisit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showChatModal: false,
      showUnregister: false,
    }
  }
  static propTypes = {
    ...requiredPropTypes,
    className: PropTypes.string,
    summary: PropTypes.element.isRequired,
  }
  render() {
    const { className, event, summary, renderDate } = this.props
    const eventTime = moment(event.StartTime)
    const currentTime = moment().tz(event.StartTimeZone)
    const isEventInPast = eventTime.isBefore(currentTime)
    const attendeeCount = event.NumAttendees
    const startTime = get(event, 'StartTime')
    const startTimeZone = get(event, 'StartTimeZone')
    const eventDate = momentTimeZone.tz(startTime, startTimeZone)
    const minAdvNotice = get(event, 'MinimumAdvancedNotice', 0)
    const registerDeadline = getRegisterDeadline(eventDate, minAdvNotice)

    return (
      <Fragment>
        <AbstractEvent
          renderDate={renderDate}
          event={event}
          summary={<div className={cn('college-visit-comp', className)}>{summary}</div>}
          details={
            <Box
              className="college-visit-details"
              minWidth={200}
              maxWidth={400}
            >
              <Title
                color="common.white"
                bgcolor={confirmed}
              >
                {event.Virtual && 'Virtual '}Visit with {event.HighSchoolName}
              </Title>
              <Section heading="When">
                <EventDuration
                  event={event}
                  isDifferentTimeZone={event.StartTimeZone !== momentTimeZone.tz.guess()}
                  showLocalTimeZone
                />
                {minAdvNotice > 0 && (
                  <span className="min-adv-notice">
                    <em>Register by {registerDeadline}.</em>
                  </span>
                )}
              </Section>
              <LocationSection
                event={event}
                registered
              />
              <Section heading="Organizer">
                <span className="counselor-name">{event.CounselorName}</span>{' '}
                <Button
                  size="small"
                  variant="text"
                  color="primary"
                  onClick={() => this.setState({ showChatModal: true })}
                >
                  Send Message
                </Button>
              </Section>
              <Section heading="Attendees">
                <FontAwesomeIcon icon={faUser} />{' '}
                <span className="student-count">
                  {attendeeCount} Registered {attendeeCount !== 1 ? 'Students' : 'Student'}
                </span>
              </Section>
              {event.RepInstructions && (
                <Section
                  maximumHeight={300}
                  heading="Instructions"
                >
                  <span
                    className="rep-instructions"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.RepInstructions) }}
                  />
                </Section>
              )}
              <Section heading="Status">
                <span className="status-label">
                  <Chip
                    label="Confirmed"
                    color="primary"
                    size="small"
                    icon={<Check />}
                  />
                </span>
              </Section>
              <Section>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                >
                  {!isEventInPast && (
                    <UnregisterAction.Trigger onOpen={() => this.setState({ showUnregister: true })} />
                  )}
                </Box>
              </Section>
            </Box>
          }
        />
        <UnregisterAction
          show={this.state.showUnregister}
          eventId={event.Id}
          onEventChange={() => this.props.onUnregistration()}
          onClose={() => this.setState({ showUnregister: false })}
        />
        <UserAware
          render={(user) => (
            <Fragment>
              <SendChatModal
                userId={user.Id}
                show={this.state.showChatModal}
                onClose={() => this.setState({ showChatModal: false })}
                recipient={{
                  userId: event.CounselorId,
                  firstName: head(event.CounselorName.split(' ')),
                  lastName: last(event.CounselorName.split(' ')),
                  school: event.HighSchoolName,
                }}
              />
            </Fragment>
          )}
        />
      </Fragment>
    )
  }
}
